import * as React from 'react';

import titleSvg from './assets/title.svg';
import * as styles from './OffersLink.css';

export const SEO_ACTION_TEXT = 'Оформить заявку';

interface IOffersLinkProps {
  onClick?(): void;
  url: string;
}

export const OffersLink: React.FC<IOffersLinkProps> = ({ onClick, url }) => {
  // В целях SEO-оптимизации показываем картинку со скрытым текстом, поэтому написан кастомный компонент.
  return (
    <a
      className={styles['container']}
      href={url}
      onClick={onClick}
      rel="noopener noreferrer"
      target="_blank"
      data-testid="OffersLink"
    >
      <img src={titleSvg} alt={SEO_ACTION_TEXT} />
      <span className={styles['seo-text']}>{SEO_ACTION_TEXT}</span>
    </a>
  );
};
